import { Resource } from 'resource-loader';
/**
 * Reference to **{@link https://github.com/englercj/resource-loader
 * resource-loader}**'s Resource class.
 * @see http://englercj.github.io/resource-loader/Resource.html
 * @class LoaderResource
 * @memberof PIXI
 */
export const LoaderResource = Resource;
export { default as Loader } from './Loader';
export { default as TextureLoader } from './TextureLoader';
export { default as LoaderPlugin } from './LoaderPlugin';
